export default {
	name: "Glossary",
	created () {
		this.$nextTick(function () {
			this.relevantData('A', 0)
			this.GitGlossarySeek(this.GlossaryData[0])
			this.ariseCombobox('#comboboxGlossary')
		});
	},
	mounted () {
		this.$nextTick(function () {
			// this.$$.navbarAnimation()
		})
	},
	data () {
		return {
			GlossaryShwoData: [],
			GlossaryData: [
				[{
					letter: 'A',
					data: [{
						name: 'ALPHA',
						content: `Alpha is a measure of the performance of an investment as compared to a suitable benchmark index. An alpha of one (the baseline value is zero) shows that the return on the investment during a specified time frame outperformed the overall market average by 1%. A negative alpha number reflects an investment that is underperforming as compared to the market average.`
					}, {
						name: 'AMERICAN-STYLE',
						content: 'A covered warrant that may be exercised on any market day up to and including the expiry date.'
					},
					{
						name: 'ASK VOLUME',
						content: 'Ask volume is the quantity of a security that sellers are willing to sell at a specified ask price. Ask volume is stated as board lots with each representing 100 units each.'
					},
					{
						name: 'ASK PRICE',
						content: 'Ask price is the lowest price a seller is willing to sell a particular security.'
					},
					{
						name: 'AT-THE-MONEY',
						content: `A situation where the covered warrant's exercise price is close to or identical to the underlying asset price. An at-the-money covered warrant has no intrinsic value, but may still have some time value (depends on time to maturity). <br/>For example if XYZ share is trading at VND 2,000, then the covered warrant with the exercise price of VND 2,000 are said to be at-the-money.`
					}
					]
				},
				{
					letter: 'B',
					data: [{
						name: 'BEAR MARKET',
						content: `A share market in which sellers dominate, resulting in generally falling prices.`
					},
					{
						name: 'BID VOLUME',
						content: `Bid volume is the quantity of a security that buyers are willing to buy at a specified bid price. Bid volume is stated as board lots with each representing 100 units each.`
					},
					{
						name: 'BID PRICE',
						content: `Bid price is the highest price a buyer is willing to purchase a particular security.`
					},
					{
						name: 'BLACK-SCHOLES MODEL',
						content: `One of the most commonly used option pricing models.`
					},
					{
						name: 'BOARD LOT',
						content: `The minimum number of covered warrants to trade on the Ho Chi Minh Stock Exchange (HSX). 1 board lot = 100 units of covered warrants.`
					},
					{
						name: 'BONUS SHARES',
						content: `Bonus shares are shares distributed by a company to its current shareholders as fully paid shares free of charge. Instead of a dividend payout, companies offer to distribute additional shares to the shareholders. For example, the company may decide to give out one bonus share for every ten shares held by existing shareholders.`
					},
					{
						name: 'BROKER',
						content: `An agent, authorised to buy and sell securities on behalf of a client.`
					},
					{
						name: 'BULL MARKET',
						content: `A share market in which buyers dominate and where prices are on a rising trend.`
					},
					{
						name: 'BREAK-EVEN LEVEL',
						content: `Refers to the price at which a transaction produces neither a gain nor a loss.`
					}
					]
				},
				{
					letter: 'C',
					data: [{
						name: 'CALL WARRANTS',
						content: `A call warrant offers its holder the right, but not obligation to purchase a certain amount of the underlying asset on a pre-determined exercise price within a pre-determined time.`
					},
					{
						name: 'CASH SETTLEMENT AMOUNT',
						content: `The positive amount received from the exercise of the covered warrant at expiry. In the event the cash settlement amount is less than or equal to zero, covered warrantholders shall not be entitled to receive any payment in respect of the covered warrants.`
					},
					{
						name: 'COVERED WARRANTS',
						content: `A warrant gives the holder the right but not the obligation to buy an underlying security at a certain price, quantity.`
					},
					{
						name: 'COVERED WARRANT HOLDER',
						content: `The person who owns the covered warrants`
					}
					]
				},
				{
					letter: 'D',
					data: [{
						name: 'DELTA',
						content: `Delta is the ratio of the change in the covered warrant to the change in the underlying asset’s price. It shows the absolute changes in the price of the covered warrant, if the price of the underlying asset changes. <br/><br/>Delta normally ranges between 0 and 1 for call warrants and 0 and -1 for put warrants. For example (assuming a covered warrant with conversion ratio of 1) a delta of 0.50 implies that if the value of the underlying changes by VND100, then the value of the call warrant should change by VND50.`
					},
					{
						name: 'DISCOUNT',
						content: `The amount by which the price of a share is quoted below its paid-up value.`
					},
					{
						name: 'DIVIDEND YIELD',
						content: `The amount of a company's annual dividend expressed as a percentage of the current price of the share of that company.`
					},
					{
						name: 'DEPOSITORY ACCOUNT',
						content: `Investors who wish to trade in securities listed on HOSE/ HSX must open Depository accounts in Vietnam Securities Depository Company (VSDC), which can be done through Depository members, i.e. stockbroking companies. Securities bought will be credited into depository accounts that the investors have opened. Likewise for securities sold, these securities will be debited from the depository accounts. Investors can use the depository account to transfer securities from one account to another, provided the transfers are within the reasons approved by Vietnam Securities Depository Company. Other transactions that depositors can perform via the depository account are registering of bank account information, updating of account particulars, reactivation of dormant account, reactivation of inactive account, deposit of share certificate, withdrawal of shares of delisted company and closing of account.`
					}
					]
				},
				{
					letter: 'E',
					data: [{
						name: 'EARNINGS PER SHARE',
						content: `The amount of a company's annual profits or earning attributable to each ordinary share of that company.`
					},
					{
						name: 'EFFECTIVE GEARING',
						content: `Measures the theoretical percentage change in covered warrant price for every 1% change in the underlying price. For example, effective gearing of 10 times, other factors being equal, means for every 1% change in underlying price, the covered warrant price moves by 10%.`
					},
					{
						name: 'EXCHANGE TRADING HOURS',
						content: `The equities trading hours are divided into two sessions for both normal and odd lot market.<br/><bt/> 
                  For Vietnam: The first session is from 9:00am – 11.30am, and the second session runs from 1.00pm – 2.45pm.`
					},
					{
						name: 'EUROPEAN STYLE',
						content: `A covered warrant that is automatically exercised on the predetermined expiry date.`
					},
					{
						name: 'EXERCISE PRICE/LEVEL',
						content: `The predetermined price/level for the covered warrant holder to buy or sell the underlying of the covered warrant. It is used to calculate the cash settlement amount of a cash-settled covered warrant at the expiry.`
					},
					{
						name: 'EXERCISE RATIO',
						content: `The number of covered warrants needed to exchange for one unit of the underlying asset.`
					},
					{
						name: 'EXPIRY DATE',
						content: `The date the covered warrant expires; where the right of the covered warrant holder to exercise the warrant ceases.`
					},
					{
						name: 'EXCHANGE TRADED FUNDS (ETF)',
						content: `ETF is the acronym for an innovative financial product known as Exchange Traded Fund. It is an open-ended investment fund listed and traded on a stock exchange. ETF combines the features of an Index fund and a stock. <bt/><bt/>
						Generally, there are three types of ETFs: equity ETFs, Leveraged & Inverse ETFs, fixed income ETFs and commodity ETFs. These ETFs consists of baskets of stocks, bonds, futures or commodities based on an index which instantly offers broad diversification and avert the risk involved in owning stock of a single company.<bt/><bt/>
						The liquidity of an ETF reflects the liquidity of the underlying basket of shares. `
					}
					]
				},
				{
					letter: 'F',
					data: [{
						name: 'FUTURES',
						content: `Futures are financial contracts obligating the buyer to purchase an asset or the seller to sell an asset on a predetermined future date and price.`
					}]
				},
				{
					letter: 'G',
					data: [{
						name: 'GAMMA',
						content: `Measures the changes of a covered warrant's delta as the price of the underlying asset changes, all other factors remain constant.`
					},
					{
						name: 'GEARING',
						content: `Gearing is the ratio of the share price to the covered warrant price and represents the leverage that the covered warrant offers.<br/><br/>

						For example, a covered warrant with gearing of 10x will have 10 times more exposure than if you purchased the underlying asset. To estimate the increase or decrease in the covered warrant price in relative to the underlying asset price, we should look at effective gearing.`
					},
					{
						name: 'GROWTH STOCKS',
						content: `Shares of companies with good prospects for increasing profits and capital size. Likely to bring shareholders future capital gains through a share price rise, high dividends, share bonuses or rights issues.`
					}
					]
				},
				{
					letter: 'H',
					data: [{
						name: 'HEDGE',
						content: `Hedging is a strategy to reduce the risk of adverse price movements in an asset. Normally, a hedge consists of taking an offsetting position in a related security to protect the value of an asset or a portfolio.`
					},
					{
						name: `DAY'S HIGH/ HIGH PRICE`,
						content: `High price refers to a security's intraday high trading price. High price indicates the security's highest price traded throughout one day of trading activity during regular trading hours.`
					},
					{
						name: 'HISTORICAL VOLATILITY',
						content: `Used as a reference to assess the previous price fluctuations of the underlying asset. Normally expressed in number of days, e.g. 10-day volatility, 90-day volatility etc.`
					}
					]
				},
				{
					letter: 'I',
					data: [{
						name: `IMPLIED VOLATILITY`,
						content: `Most important factor that affects the price of covered warrants. It refers to the estimate of future price volatility of a specified underlying and is used by the market as an indicator to decide whether a covered warrant is cheap or expensive. With all factors being equal, the higher the implied volatility, the higher the covered warrant price.`
					},
					{
						name: `INDICES`,
						content: `In relation to a stock exchange, index is a measures of a share market, or a subset of the share market, that helps investors compare current price levels with past prices to calculate market performance.`
					},
					{
						name: `INITIAL PUBLIC OFFERING (IPO)`,
						content: `An initial public offering (IPO) occurs when a company first sells common shares to investors in the public. When the company starts to offer its shares through IPOs, they are required to reveal financial information and all relevant material information about the company so that investors can make an informed decision.`
					},
					{
						name: `INSTRUMENT`,
						content: `A tradeble asset or negotiable item such as a security, commodity, derivative or index, or any item that underlies a derivative. An instrument is a means by which something of value is transferred or held.`
					},
					{
						name: `IN-THE-MONEY`,
						content: `An in-the-money option has intrinsic value more than zero.<br/><br/>

						For <strong>call</strong> warrant, it is said to be in-the-money if Underlying Price > Exercise Price;<br/>
						For <strong>put</strong> warrant, it is said to be in-the-money if Exercise Price > Underlying Price.`
					},
					{
						name: `INTRADAY MOVEMENT`,
						content: `Intraday is defined as within the day. Intraday movement refers to the price movements of a specific security throughout one day of trading activity during regular trading hours. It is to express the high and low price of a security in its trading day.`
					},
					{
						name: `INTRINSIC VALUE`,
						content: `Intrinsic value for a covered warrant is the difference between the price of the underlying asset and the exercise price. The intrinsic value can be zero, but it can never be negative.`
					},
					{
						name: `ISSUER`,
						content: `The entity that issues covered warrants, usually a financial institution, e.g. Maybank Securities Vietnam`
					},
					{
						name: `INTRADAY'S LOW/LOW PRICE`,
						content: `Intraday low refers to the lowest price at which a security trades on a given trading day. It can be lower than the closing price and is also called the Day low.`
					}
					]
				},
				{
					letter: 'J',
					data: []
				},
				{
					letter: 'K',
					data: []
				},
				{
					letter: 'L',
					data: [{
						name: `LAST PRICE`,
						content: `Last price refers to the last traded price of the particular security. Last price represents at what price points there are willing buyers and sellers and where the most recent trade occured.`
					},
					{
						name: `LAST TRADING DAY`,
						content: `For regular and negotiated market, three (3) market days immediately before the expiry date of the covered warrant. For cash market, one (1) market day before the expiry date of the covered warrant.`
					},
					{
						name: `LIMIT ORDER`,
						content: `To avoid buying or selling a security at a price higher or lower than what is wanted, it's best to place a limit order rather than a market order. A limit order is an order to buy or sell an instrument at a specific price. A buy limit order can only be executed at the limit price or lower, and a sell limit order can only be executed at the limit price or higher. When a market order is placed, the price at which an order will be filled can't be controlled.`
					},
					{
						name: `LIQUIDITY OF THE MARKET`,
						content: `The state of affairs in a share market in which it is generally easy to convert securities into cash and vice versa, without causing a movement in prices.`
					},
					{
						name: `LIQUIDITY`,
						content: `A covered warrant is considered liquid when there is:-<br/><br/>

						i. Adequate trading volume; and/ or<br/>
						ii. Sufficient depth in bid and ask price; and/ or<br/>
						iii. Adequate quantity during trading hours.`
					},
					{
						name: `LISTING DAY`,
						content: `The day the covered warrant is listed and quoted on the exchange.`
					},
					{
						name: `LIQUIDITY PROVIDER`,
						content: `Refer to MARKET MAKER.`
					},
					{
						name: `LIVE MATRIX`,
						content: `Live matrix is a live price matrix feed from Maybank Securities Vietnam market making system. It allows investors to view bids and offer prices for a warrant based on various price points in the stock or index.<br/><br/>
						The warrant prices in the Live Matrix are indicative. The actual warrant prices on the market may differ from the prices displayed on the website due to several factors.`
					},
					{
						name: `INTRADAY'S LOW/LOW PRICE`,
						content: `Intraday low refers to the lowest price at which a security trades on a given trading day. It can be lower than the closing price and is also called the Day low.`
					}
					]
				},
				{
					letter: 'M',
					data: [{
						name: `MARKET CAPITALISATION`,
						content: `The total value of a listed company's shares based on current market price.`
					},
					{
						name: `MARKET MAKER`,
						content: `Market maker provides liquidity by posting bid and offer prices on the trading system of HOSE on each market day over the life of the structured warrant. Market maker must be the issuer itself (e.g. Maybank Investment Bank Vietnam).`
					},
					{
						name: `MARKET ORDER`,
						content: `A market order is an order to buy or sell a security at the current market price. The advantage of a market order is that it is almost always guaranteed that the order will be executed (as long as there are willing buyers and sellers). `
					},
					{
						name: `MONEYNESS`,
						content: `Relationship between exercise price of the covered warrants and the underlying asset price. There are three forms of moneyness, which are <strong>In-the-Money</strong>, <strong>At-the-Money</strong> and <strong>Out-of-the-Money</strong>.`
					}
					]
				},
				{
					letter: 'N',
					data: []
				},
				{
					letter: 'O',
					data: [{
						name: `ODD LOTS`,
						content: `This is an amount of security that is smaller than the usual unit of trading in Vietnam; specifically, a quantity of less than 100 units in a transaction or a trade that is not divisible by 100.`
					},
					// {
					// 	name: `OPEN PRICE`,
					// 	content: `Open price is the price at which a security first trades upon the opening of an exchange on a trading day. For example, Indonesia Stock Exchange opens at precisely 9:00a.m, GMT+7. The price of the first trade for any listed security is its daily open price.`
					// },
					{
						name: `ORDER BOOK`,
						content: `Order Book is an 'electronic book' that shows the demand for the security at various prices on a real time basis.`
					},
					{
						name: `OUT-OF-THE-MONEY`,
						content: `An out-of-the-money option has intrinsic value equals to zero.<br/><br/>

						For <strong>call</strong> warrant, it is said to be out-of-the-money if Underlying Price < Exercise Price;<br/>
						For <strong>put</strong> warrant, it is said to be out-of-the-money if Exercise Price < Underlying Price.`
					},
					{
						name: `OUTSTANDING COVERED WARRANT QUANTITY`,
						content: `Outstanding covered warrant quantity refers to the quantity of covered warrants held by investors. Hedging by the issuer will only be executed for its outstanding positions. The higher the outstanding quantity, the higher the probability that the covered warrant price is affected by the forces of market supply and demand and vice versa. As a result, the covered warrant's price may not track the price of the underlying asset very closely.`
					}
					]
				},
				{
					letter: 'P',
					data: [
						// 	{
						// 	name: `PREMIUM`,
						// 	content: ``
						// },
						{
							name: `PROSPECTUS`,
							content: `The document to be issued by a company intending to make an issue of shares to the public.`
						}, {
							name: `PUT WARRANT`,
							content: `A put warrant offers its holder the right, but not obligation to sell a certain amount of the underlying asset on a pre-determined exercise price within a pre-determined time.`
						},
						{
							name: `PROXY`,
							content: `One who is given written authority to vote for and on behalf of a shareholder at a meeting of the company.`
						}
					]
				},
				{
					letter: 'Q',
					data: [{
						name: `QUOTATION`,
						content: `The prices of bid and offered by buyers and sellers for a security listed on a stock exchange.`
					}]
				},
				{
					letter: 'R',
					data: [{
						name: `RIGHTS ISSUE`,
						content: `Companies raise additional capital by offering to existing shareholders the rights to subscribe for new shares, at a price usually below the current market price. These rights  have a market of their own and can be traded on the stock exchange.`
					},
					{
						name: `REMISIER `,
						content: `An agent of a stockbroking company who brings business to that company in return for a share of the brokerage or commission.`
					}
					]
				},
				{
					letter: 'S',
					data: [{
						name: `SHARE SPLIT`,
						content: `When a company reduces the market price of its shares by increasing the number of outstanding share in the market, e.g. 1.000 units of VND 20.000 ordinary shares would be split into 2.000 units of 10.000 ordinary shares`
					},
					{
						name: `SHORT SELLING`,
						content: `The action of a person selling securities which he does not own at the time of selling.`
					},
					// {
					// 	name: `STRUCTURED WARRANT`,
					// 	content: `Securities which gives the covered warrant holder the right to buy or sell the underlying asset at a predetermined price and time. `
					// },
					// {
					// 	name: `STRUCTURED WARRANT CALCULATOR`,
					// 	content: `Structured Warrant calculator tool allows investors to gauge the theoretical price of a specific covered warrant based on a few inputs. Inputs needed are such as underlying price, date to maturity and/or implied volatility.<br/><br/>

					// 	Investors can gauge the price of the covered warrant based on their own perceived view of the movement in the underlying price and/or implied volatility while factoring in holding period of the covered warrant.`
					// },
					// {
					// 	name: `STRUCTURED WARRANTS TRADING HOURS`,
					// 	content: `Structured warrants trading hours would follows equity trading hours.`
					// },
					// {
					// 	name: `STRUCTURED WARRAN THOLDER`,
					// 	content: `Public who invests in the covered warrants and their names are recorded in the list of covered warrants holders.`
					// },
					// {
					// 	name: `STRUCTURED WARRANTS PROSPECTUS`,
					// 	content: `The offering document published by an Issuer in connection with the offering of covered warrants to be issued from time to time.`
					// },
					{
						name: `STOP ORDER`,
						content: `A stop order becomes a market order to buy or sell securities once the specified stop price is attained or penetrated.`
					},
					]
				},
				{
					letter: 'T',
					data: [{
						name: `THETA`,
						content: `Measures the expected daily decline in the value of a covered warrant due to time decay, all other factors remain constant. Theta is always negative as time decay is always working against a covered warrant holder.`
					},
					{
						name: `TIME DECAY`,
						content: `Time decay is the effects of time value declining as covered warrants move towards expiration.`
					},
					{
						name: `TIME VALUE`,
						content: `The difference between the covered warrant price and intrinsic value.`
					}
					]
				},
				{
					letter: 'U',
					data: [{
						name: `UNDERLYING ASSET`,
						content: `The financial instrument referenced by the covered warrant.`
					}]
				},
				{
					letter: 'V',
					data: [{
						name: `VOLATILITY`,
						content: `The uncertainty in the price movement which will affect the return of the underlying asset.<br/><br/>

						Refer to HISTORICAL VOLATILITY and IMPLIED VOLATILITY`
					},
					{
						name: `VOLUME TRADED`,
						content: `Volume traded refers to the total quantity of the specified security transacted between buyers and sellers  during a trading day throughout its regular trading hours.`
					},
					{
						name: `VOLUME WEIGHTED AVERAGE PRICE (VWAP)`,
						content: `The VWAP for a security is calculated by adding the value traded for every transaction in that share ("price" x "number of security traded") and dividing it with the total number of security traded. A VWAP can be computed for any given trading period.`
					}
					]
				},
				{
					letter: 'W',
					data: [{
						name: `WARRANTS`,
						content: `A warrant gives the holder the right but not the obligation to buy an underlying security at a certain price and time.`
					},
					{
						name: `WARRANT CALCULATOR`,
						content: `Warrant calculator tool allows investors to gauge the theoretical price of a specific warrant based on a few inputs. Inputs needed are such as underlying price, date to maturity and/or implied volatility.<br/><br/>
						Investors can gauge the price of the warrant based on their own perceived view of the movement in the underlying price and/or implied volatility while factoring in holding period of the warrant.`
					}
					]
				},
				{
					letter: 'X',
					data: []
				},
				{
					letter: 'Y',
					data: []
				},
				{
					letter: 'Z',
					data: []
				}
				],
				[{
					letter: 'A',
					data: [{
						name: `ALPHA`,
						content: `Alpha là thước đo hiệu suất của một khoản đầu tư so với một chỉ số chuẩn phù hợp. Hệ số alpha bằng 1 (giá trị cơ bản bằng 0) cho thấy lợi tức đầu tư trong một khung thời gian nhất định cao hơn mức trung bình chung của thị trường 1%. Số alpha âm phản ánh khoản đầu tư đang hoạt động kém hiệu quả so với mức trung bình của thị trường.`
					},
					]
				},
				{
					letter: 'B',
					data: [
						{
							name: `BẢN CÁO BẠCH`,
							content: `Tài liệu được phát hành bởi một công ty có ý định phát hành cổ phiếu ra công chúng.`
						},
						{
							name: `BÁN KHỐNG`,
							content: `Hành động của một người bán cổ phiếu mà mình không sở hữu tại thời điểm bán.`
						},
					]
				},
				{
					letter: 'C',
					data: [
						{
							name: `CHỨNG QUYỀN KIỂU MỸ`,
							content: `Một chứng quyền có thể được thực hiện vào bất kỳ ngày nào cho đến và bao gồm cả ngày hết hạn`
						},
						{
							name: `CHỨNG QUYỀN HÒA VỐN`,
							content: `Trường hợp giá thực hiện chứng quyền gần bằng hoặc giống hệt với giá tài sản cơ sở. Chứng quyền hòa vốn không có giá trị nội tại nhưng vẫn có thể có giá trị thời gian nào đó (tùy thuộc vào thời gian đáo hạn).<br/>
							Nếu cổ phiếu XYZ đang được giao dịch với mức giá 2,000 VND, chứng quyền mua hoặc chứng quyền bán với giá thực hiện là 2.000 VND được gọi là chứng quyền hòa vốn`
						},
						{
							name: `CHỨNG QUYỀN MUA`,
							content: `Chứng quyền cung cấp cho người sở hữu quyền nhưng không phải nghĩa vụ mua chứng khoán cơ sở ở một mức giá, số lượng nhất định.`
						},
						{
							name: `CHỨNG QUYỀN CÓ ĐẢM BẢO`,
							content: `Chứng quyền cung cấp cho người sở hữu quyền nhưng không có nghĩa vụ mua chứng khoán cơ sở ở một mức giá, số lượng nhất định.`
						},
						{
							name: `CHỨNG QUYỀN KIỂU CHÂU ÂU`,
							content: `Chứng quyền được thực hiện vào ngày đáo hạn được xác định trước`
						},
						// {
						// 	name: `CỔ PHIẾU TĂNG TRƯỞNG`,
						// 	content: `Cổ phiếu của các công ty có triển vọng tốt về tăng lợi nhuận và quy mô vốn. Có khả năng mang lại cho cổ đông lợi nhuận vốn trong tương lai thông qua việc tăng giá cổ phiếu, cổ tức cao, thưởng cổ phiếu hoặc phát hành quyền.`
						// },
						// {
						// 	name: `CHỈ SỐ`,
						// 	content: `Liên quan đến sở giao dịch chứng khoán,chỉ số là thước đo của thị trường chứng khoán hoặc một tập hợp con của thị trường chứng khoán, giúp các nhà đầu tư so sánh mức giá hiện tại với giá trong quá khứ để tính toán hiệu quả thị trường.`
						// },
						// {
						// 	name: `CHÀO BÁN LẦN ĐẦU RA CÔNG CHÚNG`,
						// 	content: `Đợt chào bán cổ phiếu lần đầu ra công chúng (IPO) xảy ra khi một công ty lần đầu tiên bán cổ phiếu phổ thông cho các nhà đầu tư ra công chúng. Nói chung, công ty chào bán cổ phiếu sơ cấp theo cách này, mặc dù đôi khi, cổ phiếu thứ cấp cũng được bán dưới dạng IPO. Để một công ty chào bán IPO, họ cần thuê một luật sư của công ty cũng như một chủ ngân hàng đầu tư để bảo lãnh cho đợt chào bán này. Việc bán cổ phiếu thực tế thường được cung cấp bởi sàn giao dịch chứng khoán hoặc cơ quan quản lý. Khi công ty bắt đầu chào bán IPO, họ thường được yêu cầu tiết lộ thông tin tài chính về công ty để các nhà đầu tư có thể đưa ra quyết định sáng suốt.`
						// },
						// {
						// 	name: `CÔNG CỤ`,
						// 	content: `Một tài sản có thể giao dịch hoặc hạng mục có thể thương lượng như chứng khoán, hàng hóa, công cụ phái sinh hoặc chỉ số hoặc bất kỳ mặt hàng nào trong phân loại công cụ phái sinh. Một công cụ là một phương tiện để chuyển giao hoặc định giá một sản phẩm nào đó.`
						// },
						{
							name: `CHỨNG QUYỀN CÓ LÃI `,
							content: `Chứng quyền có lãi có giá trị nội tại lớn hơn 0<br/><br/>
							Với chứng quyền mua: Chứng quyền có lãi khi Giá chứng khoán > Giá thực hiện<br/>
							Với chứng quyền bán: Chứng quyền có lãi khi Giá chứng khoán < Giá thực hiện<br/><br/>
						`
						},
						// {
						// 	name: `CHUYỂN ĐỘNG TRONG NGÀY`,
						// 	content: `Biến động trong ngày đề cập đến biến động giá của một loại chứng khoán cụ thể trong suốt một ngày hoạt động giao dịch trong giờ giao dịch thông thường. Nó thể hiện giá cao và giá thấp của một cổ phiếu trong ngày giao dịch.`
						// },
						{
							name: `CHỨNG QUYỀN LỖ`,
							content: `Một chứng quyền không có lãi có giá trị nội tại bằng 0. <br/><br/>
							Với chứng quyền mua: Chứng quyền không có lãi khi Giá Chứng khoán < Giá thực hiện<br/>
							Với chứng quyền bán: Chứng quyền không có lãi khi Giá Chứng khoán >  Giá thực hiện`
						},
						{
							name: `CHIA TÁCH CỔ PHIẾU`,
							content: `Khi công ty giảm giá thị trường của cổ phiếu bằng cách tăng số lượng cổ phiếu đang lưu hành trên thị trường, ví dụ 1.000 đơn vị 20.000 VND cổ phiếu cơ sở sẽ được chia thành 2.000 đơn vị của 10.000 VND cổ phiếu phổ thông.`
						},
						{
							name: `CÔNG CỤ ĐỊNH GIÁ CHỨNG QUYỀN`,
							content: `Công cụ tính chứng quyền cho phép các nhà đầu tư đánh giá giá lý thuyết của một chứng quyền cụ thể dựa trên một số thông tin đầu vào. Các yếu tố đầu vào cần thiết như giá chứng khoán cơ sở, ngày đáo hạn và/hoặc mức độ biến động ngụ ý. <br/><br/>
							Các nhà đầu tư có thể đánh giá giá của chứng quyền dựa trên quan điểm nhận thức của riêng họ về sự biến động của giá chứng khoán cơ sở và/hoặc sự độ biến động hàm ý khi tính đến thời gian nắm giữ chứng quyền.`
						}
					]
				},
				{
					letter: 'D',
					data: [{
						name: `DELTA`,
						content: `Delta là tỷ lệ giữa sự thay đổi của chứng quyền với sự thay đổi giá của tài sản cơ sở. Điều này cho thấy sự thay đổi tuyệt đối về giá của chứng quyền nếu giá của tài sản cơ sở thay đổi.<br/><br/>
						Thông thường, Delta nằm trong khoảng từ 0 đến 1 đối với chứng quyền mua và 0 và -1 đối với chứng quyền bán. Ví dụ: (giả sử chứng quyền có tỷ lệ chuyển đổi là 1), hệ số delta là 0,50 cho biết rằng nếu giá trị của tài sản cơ sở thay đổi 20 xu thì giá trị của chứng quyền mua sẽ hòa vốn 10 xu.`
					},
					// {
					// 	name: `ĐỘ ĐÀN HỒI VỀ GIÁ`,
					// 	content: `Đo lường phần trăm thay đổi lý thuyết trong giá chứng quyền cho mỗi 1% thay đổi trong giá cơ bản. Ví dụ: đòn bẩy tài chính hiệu quả gấp 10 lần, các yếu tố khác không đổi, nghĩa là cứ mỗi 1% thay đổi trong giá cơ bản, giá chứng quyền sẽ tăng 10%.`
					// },
					{
						name: `Mức đòn bẩy hiệu quả`,
						content: `Mức đòn bẩy hiệu quả là tỷ lệ giữa giá cổ phiếu và giá chứng quyền và thể hiện đòn bẩy mà chứng quyền mang lại. <br/><br/>
						Ví dụ: một chứng quyền có Mức đòn bẩy hiệu quả gấp 10 lần sẽ có mức rủi ro cao hơn 10 lần so với việc bạn mua tài sản cơ bản. Để ước tính sự tăng hoặc giảm giá chứng quyền so với giá tài sản cơ bản, chúng ta nên xem xét đòn Mức đòn bẩy hiệu quả`
					},
					{
						name: `ĐỘ BIẾN ĐỘNG LỊCH SỬ`,
						content: `Được sử dụng làm tài liệu tham khảo để đánh giá biến động giá trước đó của tài sản cơ bản. Thường được biểu thị bằng số ngày, ví dụ như biến động trong 10 ngày, biến động trong 90 ngày, v.v.`
					},
					{
						name: `ĐỘ BIẾN ĐỘNG HÀM Ý`,
						content: `Yếu tố quan trọng nhất ảnh hưởng đến giá của Chứng quyền có bảo đảm. Nó đề cập đến ước tính về sự biến động giá trong tương lai của một tài sản cơ sở cụ thể và được thị trường sử dụng như một chỉ báo để quyết định xem chứng quyền có giá rẻ hay đắt. Với tất cả các yếu tố đều bằng nhau, độ biến động ngụ ý càng cao thì giá chứng quyền càng cao. `
					},
						// {
						// 	name: `ĐỘ BIẾN ĐỘNG`,
						// 	content: `Sự không chắc chắn trong biến động giá sẽ ảnh hưởng đến lợi nhuận của tài sản cơ sở.<br/> <br/>
						// 	Tham khảo BIẾN ĐỘNG LỊCH SỬ và BIẾN ĐỘNG NGỤ Ý `
						// },
					]
				},
				{
					letter: 'E',
					data: [

					]
				},
				{
					letter: 'F',
					data: []
				},
				{
					letter: 'G',
					data: [{
						name: `GIÁ CHÀO BÁN`,
						content: `Giá chào bán là mức giá thấp nhất mà người bán sẵn sàng bán một loại chứng khoán cụ thể.`
					},
					{
						name: `GIÁ MỞ CỬA`,
						content: `Lệnh ATO (At the Open) là lệnh giao dịch chứng khoán với mức giá tại lúc mở cửa. Khi khớp lệnh, lệnh này sẽ được ưu tiên đứng trước lệnh giới hạn và chỉ có hiệu lực tại thời điểm đầu phiên.<br/><br/>
						Mức giá được lựa chọn là mức giá mở cửa được xác định trong 15 phút đầu của phiên giao dịch. Trong đó, lệnh ATO sẽ được đặt trước các lệnh giới hạn khi bắt đầu so khớp lệnh trong phiên giao dịch. `
					},
					{
						name: `GIÁ ĐÓNG CỬA`,
						content: `Lệnh ATC (At The Close) là lệnh mua hoặc bán sẵn sàng chấp nhận mọi mức giá trong phiên giao dịch khớp lệnh định kỳ đóng cửa.  Khi khớp lệnh, lệnh này sẽ được ưu tiên đứng trước lệnh giới hạn và chỉ có hiệu lực tại thời điểm cuối phiên.<br/><br/>
						Mức giá được lựa chọn là mức giá mở cửa được xác định trong 15 phút cuối của phiên giao dịch. Trong đó, lệnh ATC sẽ được đặt trước các lệnh giới hạn khi bắt đầu so khớp lệnh trong phiên giao dịch.  `
					},
					{
						name: `GIÁ CHÀO MUA`,
						content: `Giá chào mua là mức giá cao nhất mà người mua sẵn sàng mua một loại chứng khoán cụ thể.`
					},
					{
						name: `GIÁ THỰC HIỆN`,
						content: `Mức giá/mức xác định trước để người nắm giữ chứng quyền mua hoặc bán tài sản cơ sở của chứng quyền. Nó được sử dụng để tính toán số tiền thanh toán của chứng quyền thanh toán bằng tiền khi đáo hạn.`
					},
					{
						name: `GAMMA`,
						content: `Đo lường sự thay đổi của delta của chứng quyền khi giá của tài sản cơ sở thay đổi, tất cả các yếu tố khác không đổi.`
					},
					// {
					// 	name: `GIÁ CAO NHẤT`,
					// 	content: `Giá cao đề cập đến giá giao dịch cao trong ngày của chứng khoán. Giá cao cho biết giá cao nhất của cổ phiếu được giao dịch trong suốt một ngày hoạt động giao dịch trong giờ giao dịch thông thường`
					// },
					{
						name: `GIÁ TRỊ NỘI TẠI`,
						content: `Giá trị nội tại của chứng quyền là chênh lệch giữa giá cổ phiếu cơ sở và giá thực hiện . Giá trị nội tại có thể bằng 0 nhưng không bao giờ âm`
					},
					{
						name: `GIÁ ĐÓNG CỬA`,
						content: `Giá đóng cửa đề cập đến giá đóng cửa của chứng khoán cụ thể. Giá đóng thể hiện mức giá mà người mua và người bán sẵn sàng vào cuối ngày giao dịch.`
					},
					// {
					// 	name: `GIÁ THẤP/THẤP TRONG NGÀY`,
					// 	content: `Mức thấp trong ngày đề cập đến mức giá thấp nhất mà chứng khoán giao dịch trong một ngày giao dịch nhất định. Nó có thể thấp hơn giá đóng cửa và còn được gọi là mức thấp trong ngày.`
					// },
					{
						name: `GIẢM GIÁ TRỊ THỜI GIAN`,
						content: `Sự quy giảm giá trị theo thời gian của chứng quyền khi chứng quyền tiến đến đáo hạn`
					},
					{
						name: `GIÁ TRỊ THỜI GIAN`,
						content: `Chênh lệch giữa giá chứng quyền và giá trị nội tại.`
					},
						// {
						// 	name: `GIÁ TRUNG BÌNH CÓ TRỌNG LƯỢNG KHỐI LƯỢNG (VWAP)`,
						// 	content: `VWAP cho một cổ phiếu được tính bằng cách cộng giá trị được giao dịch cho mọi giao dịch về cổ phiếu đó ("giá" x "số lượng cổ phiếu được giao dịch") và chia nó với Tổng số lượng cổ phiếu được giao dịch.VWAP có thể được tính cho bất kỳ khoảng thời gian giao dịch nhất định nào.`
						// },
					]
				},
				{
					letter: 'H',
					data: [
						// 	{
						// 	name: `HỢP ĐỒNG TƯƠNG LAI`,
						// 	content: `Hợp đồng tương lai là hợp đồng tài chính bắt buộc người mua phải mua một tài sản hoặc người bán phải bán một tài sản.`
						// }
					]
				},
				{
					letter: 'I',
					data: [
					]
				},
				{
					letter: 'J',
					data: [
					]
				},
				{
					letter: 'K',
					data: [{
						name: `KHỐI LƯỢNG CHÀO BÁN`,
						content: `Khối lượng chào bán là số lượng chứng khoán mà người bán sẵn sàng bán ở một mức giá chào bán cụ thể. Khối lượng bán được thể hiện dưới dạng lô bảng với mỗi lô đại diện cho 100 đơn vị (cổ phiếu) mỗi lô.`
					},
					{
						name: `KHỐI LƯỢNG CHÀO MUA`,
						content: `Khối lượng đặt mua là số lượng chứng khoán mà người mua sẵn sàng mua ở một mức giá chào mua nhất định. Khối lượng đặt mua được thể hiện dưới dạng lô bảng với mỗi lô đại diện cho 100 đơn vị (cổ phiếu) mỗi lô.`
					},
					{
						name: `KHỐI LƯỢNG GIAO DỊCH`,
						content: `Khối lượng giao dịch đề cập đến tổng số lượng cổ phiếu hoặc chứng quyền được giao dịch giữa người mua và người bán chứng khoán được chỉ định trong một ngày giao dịch trong suốt giờ giao dịch thông thường của nó.`
					},

					]
				},
				{
					letter: 'L',
					data: [{
						name: `LÔ`,
						content: `Số lượng chứng quyền tối thiểu được giao dịch trên HOSE. 1 lô giao dịch = 100 đơn vị chứng quyền`
					},
					// {
					// 	name: `LỢI SUẤT CỔ TỨC`,
					// 	content: `Số tiền cổ tức hàng năm của một công ty được biểu thị bằng phần trăm giá hiện tại của cổ phiếu của công ty đó.`
					// },
					// {
					// 	name: `LỆNH GIỚI HẠN`,
					// 	content: `Để tránh mua hoặc bán một cổ phiếu ở mức giá cao hơn hoặc thấp hơn mức mong muốn, tốt nhất nên đặt lệnh giới hạn thay vì lệnh thị trường. Lệnh giới hạn là lệnh mua hoặc bán một công cụ ở một mức giá cụ thể. Lệnh giới hạn mua chỉ có thể được thực hiện ở mức giá giới hạn hoặc thấp hơn và lệnh giới hạn bán chỉ có thể được thực hiện ở mức giá giới hạn hoặc cao hơn. Khi một lệnh thị trường được đặt, giá mà lệnh sẽ được thực hiện sẽ không thể kiểm soát được.`
					// },
					// {
					// 	name: `LỆNH THỊ TRƯỜNG`,
					// 	content: `Lệnh thị trường là lệnh mua hoặc bán một cổ phiếu ở mức giá thị trường hiện tại. Ưu điểm của lệnh thị trường là nó hầu như luôn được đảm bảo rằng lệnh sẽ được thực hiện (miễn là có người mua và người bán sẵn sàng).`
					// },
					{
						name: `LÔ LẺ`,
						content: `Đây là lượng cổ phiếu nhỏ hơn đơn vị giao dịch thông thường ở Việt Nam; cụ thể là số lượng dưới 100 cổ phiếu trong một giao dịch hoặc giao dịch không chia hết cho 100.`
					},
						// {
						// 	name: `LỆNH DỪNG`,
						// 	content: `Lệnh dừng trở thành lệnh thị trường để mua hoặc bán chứng khoán sau khi đạt được hoặc vượt qua mức giá dừng được chỉ định.`
						// },
					]
				},
				{
					letter: 'M',
					data: [
						{
							name: `MÔ HÌNH "BLACK-SCHOLES`,
							content: `Một trong những mô hình định giá quyền chọn được sử dụng phổ biến nhất.`
						},
						{
							name: `MÔI GIỚI`,
							content: `Một đại lý, được ủy quyền mua và bán cổ phiếu thay mặt cho khách hàng.`
						},
						{
							name: `MỨC HÒA VỐN`,
							content: `Đề cập đến mức giá mà tại đó một giao dịch không tạo ra lãi hay lỗ.`
						},
						{
							name: `MỨC CHIẾT KHẤU`,
							content: `Số tiền mà giá của một cổ phiếu được niêm yết dưới giá trị đã thanh toán của nó.`
						},
						{
							name: `MA TRẬN TRỰC TIẾP`,
							content: `Ma trận trực tiếp là nguồn cấp dữ liệu ma trận giá trực tiếp từ hệ thống tạo lập thị trường của Công ty Chứng khoán Maybank. Nó cho phép các nhà đầu tư xem giá mua và giá chào bán cho chứng quyền dựa trên các mức giá khác nhau trong cổ phiếu hoặc chỉ số. <br/><br/>
							Giá chứng quyền trong Ma trận trực tiếp mang tính biểu thị. Giá bảo đảm thực tế trên thị trường có thể khác với giá hiển thị trên trang web do một số yếu tố.`
						},
						{
							name: `MÔI GIỚI CHUYÊN NGHIỆP`,
							content: `Một đại lý của một công ty môi giới chứng khoán mang lại hoạt động kinh doanh cho công ty đó để đổi lấy một phần phí môi giới hoặc hoa hồng.`
						},
					]
				},
				{
					letter: 'N',
					data: [{
						name: `NGƯỜI SỞ HƯU CHỨNG QUYỀN`,
						content: `Người nắm giữ chứng quyền`
					},
					{
						name: `NGÀY ĐÁO HẠN`,
						content: `Ngày mà Chứng quyền hết hạn; khi quyền của người nắm giữ chứng quyền được thực hiện`
					},
					{
						name: `NGÀY GIAO DỊCH CUỐI CÙNG`,
						content: `Hai (2) ngày giao dịch trước ngày đáo hạn`
					},
					{
						name: `NGÀY NIÊM YẾT`,
						content: `Ngày chứng quyền được niêm yết và trên sàn giao dịch.`
					},
					// {
					// 	name: `NHÀ CUNG CẤP THANH KHOẢN`,
					// 	content: `Hãy tham khảo NHÀ TẠO LẬP THỊ TRƯỜNG bên dưới.`
					// },
					{
						name: `NHÀ TẠO LẬP THỊ TRƯỜNG`,
						content: `Nhà tạo lập thị trường cung cấp thanh khoản cho chứng quyền bằng cách đặt lệnh mua và bán trên HOSE vào mỗi ngày giao dịch trong suốt thời gian hiệu lực của chứng quyền. Nhà tạo lập thị trường cho Chứng quyền là Tổ chức phát hành chứng quyền.`
					},
						// {
						// 	name: `NGƯỜI ĐƯỢC ỦY QUYỀN `,
						// 	content: `Người được ủy quyền bằng văn bản để bỏ phiếu và thay mặt cổ đông tại cuộc họp của công ty.`
						// }
					]
				},
				{
					letter: 'O',
					data: [

					]
				},
				{
					letter: 'P',
					data: [
						// 	{
						// 	name: `PHÁT HÀNH THƯỞNG`,
						// 	content: `Phát hành thêm thưởng là cổ phiếu được một công ty phân phối cho các cổ đông hiện tại dưới dạng cổ phiếu được thanh toán đầy đủ miễn phí. Thay vì trả cổ tức, các công ty đề nghị phân phối thêm cổ phiếu cho các cổ đông. Ví dụ, công ty có thể quyết định tặng một cổ phiếu thưởng cho mỗi 10 cổ phiếu do cổ đông hiện hữu nắm giữ.`
						// },
						{
							name: `PHÒNG NGỪA RỦI RO`,
							content: `Phòng ngừa rủi ro là một chiến lược nhằm giảm rủi ro biến động giá bất lợi của một tài sản. Thông thường, phòng ngừa rủi ro bao gồm việc đảm nhận vị thế bù đắp trong chứng khoán liên quan để bảo vệ giá trị của tài sản hoặc danh mục đầu tư.`
						},
						// {
						// 	name: `PHẦN BÙ/ PHẦN THƯỞNG`,
						// 	content: `Đo lường tỷ lệ phần trăm của tài sản cơ sở phải tăng (Chứng quyền mua) hoặc giảm (Chứng quyền bán) để người nắm giữ chứng quyền có thể hòa vốn nếu người đó giữ chứng quyền cho đến khi hết hạn.`
						// },

					]
				},
				{
					letter: 'Q',
					data: [
						{
							name: `QUỸ HOÁN ĐỔI DANH MỤC`,
							content: `ETF là từ viết tắt của một sản phẩm tài chính sáng tạo được gọi là Exchange Traded Fund. Đây là một quỹ đầu tư mở được niêm yết và giao dịch trên sàn giao dịch chứng khoán. ETF kết hợp các tính năng của quỹ chỉ số và cổ phiếu.<br/><br/>
							Nói chung, có ba loại ETF: ETF vốn cổ phần, ETF đòn bẩy & nghịch đảo, ETF thu nhập cố định và ETF hàng hóa. Các quỹ ETF này bao gồm các giỏ cổ phiếu, trái phiếu, hợp đồng tương lai hoặc hàng hóa dựa trên một chỉ số, ngay lập tức mang lại sự đa dạng hóa rộng rãi và ngăn chặn rủi ro liên quan đến việc sở hữu cổ phiếu của một công ty. <br/><br/>
							Tính thanh khoản của ETF phản ánh tính thanh khoản của rổ cổ phiếu cơ bản.`
						},
						{
							name: `QUYỀN MUA CỔ PHIẾU`,
							content: `Các công ty huy động thêm vốn bằng cách cung cấp cho các cổ đông hiện hữu quyền đăng ký mua cổ phiếu mới, với mức giá thường thấp hơn giá thị trường hiện tại.`
						},
					]
				},
				{
					letter: 'R',
					data: [
					]
				},
				{
					letter: 'S',
					data: [{
						name: `SỐ TIỀN THANH TOÁN`,
						content: `Số tiền dương nhận được từ việc thực hiện chứng quyền khi hết hạn. Trong trường hợp Số tiền thanh toán bằng tiền mặt nhỏ hơn hoặc bằng 0, người nắm giữ chứng quyền sẽ không có quyền nhận bất kỳ khoản thanh toán nào đối với chứng quyền có bảo đảm.`
					},
					// {
					// 	name: `SỔ LỆNH`,
					// 	content: `Sổ lệnh là sổ điện tử thể hiện nhu cầu mua cổ phiếu công ty ở nhiều mức giá khác nhau theo thời gian thực.`
					// },
					{
						name: `SỐ LƯỢNG CHỨNG QUYỀN LƯU HÀNH`,
						content: `Số lượng chứng quyền đang lưu hành phản ánh số lượng chứng quyền mà nhà đầu tư nắm giữ. Việc phòng ngừa rủi ro của các tổ chức phát hành sẽ chỉ được thực hiện đối với các vị thế lưu hành. Số lượng lưu hành càng cao thì khả năng giá chứng quyền bị ảnh hưởng bởi pbiến động giá trên thị trường chứng khoán càng cao. Vì vậy, giá chứng quyền có thể không phản ánh giá của cổ phiếu cơ sở . `
					},

					]
				},
				{
					letter: 'T',
					data: [

						// {
						// 	name: `THỊ TRƯỜNG GẤU`,
						// 	content: `Một thị trường chứng khoán trong đó người bán chiếm ưu thế, dẫn đến giá cả thường giảm.`
						// },
						// {
						// 	name: `THỊ TRƯỜNG BÒ`,
						// 	content: `Một thị trường chứng khoán trong đó người mua chiếm ưu thế và giá đang có xu hướng tăng.			`
						// },
						{
							name: `TÀI KHOẢN LƯU KÝ `,
							content: `Nhà đầu tư muốn giao dịch chứng khoán niêm yết trên HOSE phải mở tài khoản lưu ký tại Tổng công ty lưu ký Chứng khoán Việt Nam qua thành viên lưu ký, tức là công ty môi giới chứng khoán. 
					`
						},
						{
							name: `THU NHẬP TRÊN MỖI CỔ PHIẾU`,
							content: `Số tiền lợi nhuận hoặc thu nhập hàng năm của một công ty được quy cho mỗi cổ phiếu phổ thông của công ty đó.`
						},
						// {
						// 	name: `THỜI GIAN GIAO DỊCH CỔ PHIẾU`,
						// 	content: `Giờ giao dịch chứng khoán được chia làm hai phiên cho cả thị trường lô thường và lô lẻ.
						// 	Đối với Việt Nam: Buổi đầu tiên từ 9h – 11h30 và buổi thứ 2 từ 13h – 2h45.`
						// },
						{
							name: `TỶ LỆ CHUYỂN ĐỔI`,
							content: ` Số lượng chứng quyền cần thiết để đổi lấy một đơn vị cổ phiếu cơ sở.`
						},
						{
							name: `TỔ CHỨC PHÁT HÀNH`,
							content: `Đơn vị phát hành chứng quyền, thường là Công ty chứng khoán, Công ty Trách nhiệm hữu hạn Chứng khoán Maybank`
						},
						// {
						// 	name: `THANH KHOẢN CỦA THỊ TRƯỜNG`,
						// 	content: `Tình trạng trên thị trường chứng khoán trong đó nhìn chung có thể dễ dàng chuyển đổi chứng khoán thành tiền mặt và ngược lại mà không gây ra biến động về giá.`
						// },
						// {
						// 	name: `THANH KHOẢN CỦA CHỨNG QUYỀN`,
						// 	content: `Chứng quyền được coi là có tính thanh khoản khi có:-<br/><br/>
						// 	i. Khối lượng giao dịch vừa đủ; và/hoặc <br/>
						// 	ii. Đủ độ sâu trong giá chào mua và giá chào bán; và/hoặc <br/>
						// 	iii. Số lượng trong giờ giao dịch.`
						// },
						{
							name: `TRẠNG THÁI CHỨNG QUYỀN`,
							content: `Mối quan hệ giữa giá thực hiện và giá tài sản cơ sở. Có ba trạng thái chứng quyền, đó là: Chứng quyền có lãi, chứng quyền hòa vốn và chứng quyền lỗ`
						},
						{
							name: `THETA`,
							content: `Đo lường mức giảm dự kiến hàng ngày về giá trị của chứng quyền do sự suy giảm theo thời gian, tất cả các yếu tố khác không đổi. Theta luôn âm vì sự suy giảm thời gian luôn gây bất lợi cho người nắm giữ chứng quyền.`
						},
						{
							name: `TÀI SẢN CƠ SỞ`,
							content: `Công cụ tài chỉnh được dùng làm tài sản tham chiếu cho chứng quyền`
						},
					]
				},
				{
					letter: 'U',
					data: []
				},
				{
					letter: 'V',
					data: [
						// {
						// 	name: `VỐN HÓA THỊ TRƯỜNG`,
						// 	content: `Tổng giá trị cổ phiếu của một công ty niêm yết dựa trên giá thị trường hiện tại.`
						// },

					]
				},
				{
					letter: 'W',
					data: [
					]
				},
				{
					letter: 'X',
					data: []
				},
				{
					letter: 'Y',
					data: [
						// 	{
						// 	name: `YẾT GIÁ`,
						// 	content: `Giá chào mua và chào bán của người mua và người bán đối với chứng khoán niêm yết trên sàn giao dịch chứng khoán.`
						// },
					]
				},
				{
					letter: 'Z',
					data: []
				}
				]
			],
			GlossaryT: 'TERMS',
			GlossaryD: 'DEFINITION',
			GlossarySeek: [],
			dataindex: 0,
			letter: '',
			indexN: 0,

		};
	},
	computed: {

	},
	watch: {

	},
	methods: {
		// 改变语言
		ChangeLanguage: function (index) {
			$('#Glossary').find('.btnBox').find('button').eq(index).addClass('mark')
			$('#Glossary').find('.btnBox').find('button').eq(index).siblings('button').removeClass('mark')
			this.dataindex = index
			this.relevantData(this.letter, this.indexN)
			this.GitGlossarySeek(this.GlossaryData[index])
			if (index == 0) {
				this.GlossaryT = 'TERMS'
				this.GlossaryD = 'DEFINITION'
			} else {
				this.GlossaryT = 'Thuật ngữ'
				this.GlossaryD = 'Giải thích'
			}

		},
		// 点击显示相应数据
		relevantData: function (letter, index) {
			this.indexN = index
			this.letter = letter
			$('#Glossary').find('.content').find('li').find('p').slideUp();
			$('#Glossary').find('.content').find('li').find('i').addClass('bi-caret-down-fill')
			$('#Glossary').find('.content').find('li').find('i').removeClass('bi-caret-up-fill')
			$('#Glossary').find('.letterBox').find('th').eq(index).addClass('markth')
			$('#Glossary').find('.letterBox').find('th').eq(index).siblings('th').removeClass('markth')
			this.GlossaryShwoData = this.GlossaryData[this.dataindex].filter(item => item.letter == letter)
			this.GlossaryShwoData = this.GlossaryShwoData[0].data
		},
		// 获得 搜索框数据
		GitGlossarySeek: function (data) {
			this.GlossarySeek = []
			$.each(data, (i, c) => {
				$.each(c.data, (di, dc) => {
					this.GlossarySeek.push([dc.name, i, di])
				})
			})
		},
		// 详细内容显示和隐藏
		minuteShow: function (index, ife) {
			if ($('#Glossary').find('.content').find('li').eq(index).find('i').hasClass('bi-caret-up-fill')) {
				$('#Glossary').find('.content').find('li').eq(index).find('i').addClass('bi-caret-down-fill')
				$('#Glossary').find('.content').find('li').eq(index).find('i').removeClass('bi-caret-up-fill')
			} else {
				$('#Glossary').find('.content').find('li').eq(index).find('i').addClass('bi-caret-up-fill')
				$('#Glossary').find('.content').find('li').eq(index).find('i').removeClass('bi-caret-down-fill')
			}
			console.log();
			if (ife) {
				$('#Glossary').find('.content').find('li').eq(index).find('p').slideToggle();
			} else {
				let win = $(window)
				setTimeout(function () {
					$('#Glossary').find('.content').find('li').eq(index).find('p').slideToggle();
					win.scrollTop($('#Glossary').find('.content').find('li').eq(index).offset().top)
				}, 10);
			}

		},
		// 出现combobox
		ariseCombobox: function (id, index) {
			let _this = this
			this.$$.jqcombobox(id)
			$(id).combobox({
				select: function (event, ui) {
					_this.relevantData(this.value.split(',')[0].split('')[0], this.value.split(',')[1])
					_this.minuteShow(this.value.split(',')[2])
				}
			});
			$(id).parent().find('input').attr('placeholder', 'Type to Search')
			this.$$.inputEmpty($(id).parent())
		},
	}
};